module.exports = __webpack_public_path__ + "img/42a6c7f72aae587c557b21132023a5d4.png";